import { getGlobal } from "@/functions/getGlobal";
import { blog_helper } from "@/helpers/blog_helper";
import Blog from "@/components/Blog";
import { consultant_helper } from "@/helpers/consultant_helper"; 
import SeoHead from "@/components/SeoHead";
import InsightHero from "@/components/InsightHero";
import Insights from "@/components/Insights";

export default function BlogPage({ filtered_blogs, blog }) {
  const global = getGlobal();

  const consultant = consultant_helper.fetch({filter: (i) => (i.name == blog.author)})[0]

  return (
    <>
      <main>
        <SeoHead
            page_name={`${blog?.title} · Omega`}
            canonical_link={`https://www.omegaresource.co.uk/blog/${blog?.url_slug}/`}
            robots="noindex, follow"
          />
        <InsightHero title={blog.title} tags={blog.tags} publish_date={blog.publish_date} />
        <Blog blog={blog} consultant={consultant} filtered_blogs={filtered_blogs} />
        <Insights title="Insights" highlight="Insights" color_variant="purple" items={filtered_blogs} />
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const blog = blog_helper.find(url_slug);
  const all_blogs = blog_helper.fetch();

  const filtered_blogs = all_blogs
  .filter(item => item.url_slug !== url_slug)
  .filter(item => item.category === blog.category)
  .sort((a, b) => new Date(b.publish_date) - new Date(a.publish_date))
  .slice(0, 3);

  return {
    props: {
      filtered_blogs,
      blog
    },
  };
}

export async function getStaticPaths() {
  return { paths: blog_helper.toPaths(), fallback: false };
}
